
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface RejectionReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  rejectionReason: string;
}

export function RejectionReasonModal({
  isOpen,
  onClose,
  rejectionReason,
}: RejectionReasonModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>เหตุผลที่ไม่อนุมัติ</DialogTitle>
        </DialogHeader>
        <div className="p-4">
          <p className="text-gray-700">{rejectionReason}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
